import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {EntityDescriptionSectionApiModel} from "./entity-description.section.api-model";
import {EntityDescriptionElementApiModel} from "../element/entity-description.element.api-model";
import {EntityDescriptionElementDomainModel} from "../element/entity-description.element.domain-model";

export class EntityDescriptionSectionDomainModel extends BaseDomainModel {
  apiModel: EntityDescriptionSectionApiModel;

  constructor(model: EntityDescriptionSectionApiModel) {
    super(model);

    this.name = model.name;
    this.elements = model.elements?.map((element: EntityDescriptionElementApiModel)  => new EntityDescriptionElementDomainModel(element));
  }
}
